import React from 'react'

const Strong = ({ children }) => {
  return <strong className="text-lg">{children}</strong>
}

export default Strong
